import React, { useState, useEffect } from 'react';
import { FormikProps } from 'formik';
import Multiselect from 'multiselect-react-dropdown';
import { KTSVG } from '../../../../../_metronic/helpers';
import DateField from '../../../../../components/textFields/DateField';
import labelKey from "../../../../localization/label.json";
import { constraintConfig } from '../../../../../constraintConfig';
import { FaInfoCircle } from 'react-icons/fa';

type Props = {
  formik: FormikProps<any>;
  getAllManger: any;
  getAllRolesData: any;
};

export const SpecialPermissionStep: React.FC<Props> = ({ formik, getAllManger }) => {
  const [selected, setSelected] = useState<any[]>([]);

  // Prepare options for Multiselect
  const options = (getAllManger?.result || []).map((user: any) => ({
    value: String(user.id),
    label: `${user.value}`,
    firstName: user.firstName,
    lastName: user.lastName
  }));

  useEffect(() => {
    if (formik.values.orgUserImpersonate && options.length > 0) {
      const selectedOptions = options.filter((option: any) =>
        formik.values.orgUserImpersonate.some(
          (imp: any) => imp.impersonateUserId === parseInt(option.value)
        )
      );
      setSelected(selectedOptions);
    } else {
      setSelected([]);
    }

    // Sync allowImpersonation with backend-driven isOrgUserImpersonate
    if (formik.values.allowImpersonation !== formik.values.isOrgUserImpersonate) {
      formik.setFieldValue("allowImpersonation", formik.values.isOrgUserImpersonate);
    }
  }, [formik.values.orgUserImpersonate, options, formik.values.isOrgUserImpersonate]);

  // Transform selected users to the required format
  const transformToImpersonateFormat = (selectedList: any[]) => {
    return selectedList.map((option: any) => {
      // Check if this user already exists in the current impersonation data
      const existingEntry = formik.values.orgUserImpersonate?.find(
        (imp: any) => imp.impersonateUserId === parseInt(option.value)
      );

      return {
        orgUserImpersonateId: existingEntry?.orgUserImpersonateId || 0, // Preserve existing ID or set to 0 for new entries
        impersonateUserId: parseInt(option.value),
        impersonateUserName: `${option.label}`
      };
    });
  };

  return (
    <div className='pb-5 pe-3' data-kt-stepper-element='content'>
      <div className="w-100">
        {/* Title */}
        <div className="text-center mb-5">
          <h1 className="text-dark fw-bolder mb-3">User Permissions</h1>

        </div>


        <div className='col-lg-4'>
          <DateField
            label={labelKey.importFromCCFeedDate}
            // required={true}
            selected={formik.values.ccFeedFrom ? new Date(formik.values.ccFeedFrom) : null}
            onChange={(date) => formik.setFieldValue('ccFeedFrom', date)} />
        </div>



        <div className='d-flex flex-wrap mt-3'>
          {String(formik.values?.userRole?.roleID) === constraintConfig.roleID.role4.toString() ||
            String(formik.values?.userRole?.roleID) === constraintConfig.roleID.role10.toString() ? (
            <div className="col-md-4 col-xl-3  mb-5">
              <label className='form-label fs-5 fw-bold'>{labelKey.orgReportsPermision}</label>
              <div className="form-check form-switch">
                <input
                  className="form-check-input cursor-pointer mt-3"
                  type="checkbox"
                  role="switch"
                  id={`flexSwitchCheckChecked`}
                  {...formik.getFieldProps('reportPermision')}
                  checked={formik.values.reportPermision}
                />
              </div>
            </div>
          ) : null}
          {String(formik.values?.userRole?.roleID) === constraintConfig.roleID.role4.toString() ||
            String(formik.values?.userRole?.roleID) === constraintConfig.roleID.role5.toString() ? (
            <div className="col-md-4 col-lg-4 col-xl-3 mb-5">
              <label className='form-label fs-5 fw-bold'>{labelKey.excludeMileageCalcLogic}
                <FaInfoCircle className='ms-2'
                  data-tooltip-id='tooltip'
                  data-tooltip-content='If this option is Yes, then Home to Office for Single trip & Office to Home For Round Trip distance calculation will not be applied on Mileage category for this user' />
              </label>
              <div className="form-check form-switch">
                <input
                  className="form-check-input cursor-pointer mt-3"
                  type="checkbox"
                  role="switch"
                  id={`flexSwitchCheckChecked`}
                  {...formik.getFieldProps('excludeMileageCalculationLogic')}
                  checked={formik.values.excludeMileageCalculationLogic}
                />
              </div>
            </div>) : null}

          {String(formik.values?.userRole?.roleID) === constraintConfig.roleID.role4.toString() ||
            String(formik.values?.userRole?.roleID) === constraintConfig.roleID.roleExecutive.toString() ? (
            <>
              {formik.values?.userPermission?.map((permission: any, index: any) => (
                <div className="col-md-4 col-lg-4 col-xl-3 mb-5" key={index}>
                  <label className="form-label fs-5 fw-bold">{permission?.key}</label>
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input cursor-pointer mt-3"
                      type="checkbox"
                      role="switch"
                      id={`permission-${index}`}
                      checked={permission.value}
                      onChange={(e) => {
                        const updatedPermissions = formik.values.userPermission.map((perm: any, idx: any) =>
                          idx === index ? { ...perm, value: e.target.checked } : perm
                        );
                        formik.setFieldValue('userPermission', updatedPermissions); // Update Formik's state
                      }}
                    />
                  </div>
                </div>
              ))}

            </>
          ) : null}
          <div className="col-md-4 col-lg-4 col-xl-3 mb-5">
            <label className='form-label fs-5 fw-bold'>{labelKey.excludeSupportUser}</label>
            <div className="form-check form-switch">
              <input
                className="form-check-input cursor-pointer mt-3"
                type="checkbox"
                role="switch"
                id={`flexSwitchCheckChecked`}
                {...formik.getFieldProps('excludeSupportUser')}
                checked={formik.values.excludeSupportUser}
              />
            </div>
          </div>





          <div className="col-md-4 col-lg-4 col-xl-3 mb-5">
            <label className='form-label fs-5 fw-bold'> Allow Impersonate as User</label>
            <div className="form-check form-switch">
              <input
                className="form-check-input cursor-pointer mt-3"
                type="checkbox"
                role="switch"
                id="impersonationToggle"
                {...formik.getFieldProps('excludeSupportUser')}
                checked={formik.values.isOrgUserImpersonate || false}
                onChange={(e) => {
                  const checked = e.target.checked;

                  // Update both fields together
                  formik.setFieldValue("isOrgUserImpersonate", checked);
                  formik.setFieldValue("allowImpersonation", checked);

                  if (!checked) {
                    // Clear impersonation data when toggle is off
                    formik.setFieldValue("orgUserImpersonate", []);
                    setSelected([]);
                  } else {
                    // Initialize empty array if null
                    if (!formik.values.orgUserImpersonate) {
                      formik.setFieldValue("orgUserImpersonate", []);
                    }
                  }
                }}
              />
            </div>
          </div>

        </div>
        {/* Multiselect Dropdown */}
        {formik.values.allowImpersonation && (
          <div className="fv-row mb-10">
            <label className="form-label fs-6 fw-bold mb-3">
              {/* <KTSVG
                path="/media/icons/duotune/communication/com006.svg"
                className="svg-icon-2 me-2"
              /> */}
              Select Users for Impersonation
            </label>

            <div className='col-md-12 mb-10'>
              <Multiselect
                options={options}
                selectedValues={selected}
                onSelect={(selectedList) => {
                  setSelected(selectedList);
                  const impersonateData = transformToImpersonateFormat(selectedList);
                  formik.setFieldValue('orgUserImpersonate', impersonateData);
                }}
                onRemove={(selectedList) => {
                  setSelected(selectedList);
                  const impersonateData = transformToImpersonateFormat(selectedList);
                  formik.setFieldValue('orgUserImpersonate', impersonateData);
                }}
                displayValue="label"
                showArrow={true}
                className='default-input rounded'
                placeholder="Select Users"
                avoidHighlightFirstOption={true}
                hidePlaceholder={false}
                style={{
                  chips: {
                    background: '#0095E8'
                  },
                  searchBox: {
                    border: '1px solid #E4E6EF',
                    borderRadius: '0.475rem',
                    padding: '0.5rem'
                  }
                }}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};